import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AttachmentListComponent } from '../../list/attachment-list/attachment-list.component';
import { ApiService } from '../../../services';

@Component({
    selector: 'sn-usc-attachment-lookup',
    templateUrl: './usc-attachment-lookup.component.html',
    styleUrls: ['./usc-attachment-lookup.component.css'],
    host: {
        '[style.display]': '"flex"',
        '[style.flex-direction]': '"column"',
        '[style.overflow]': '"hidden"'
    }
})
export class UscAttachmentLookupComponent implements OnInit {
    @Input() view: string;
    @Input() data: any;
    @Input() related_type: string;
    @Input() related_ID: number;
    @Input() mode: string;

    constructor(
        public activeModal: NgbActiveModal,
        public apiService: ApiService,
    ) { }

    ngOnInit() {
        console.log("UscAttachmentLookupComponent", this.mode);
    }

    downloadAttachment(event: any) {
        if (this.mode == "viewer") {
            if (event && event.selectedItem) {
                // this.activeModal.close(event);
                this.apiService.downloadFile(event.selectedItem);
            }
        }
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-attachment-lookup/usc-attachment-lookup.component.ts